import { Button } from '@/components/ui/button';
import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { centsToInitialValue } from '@/lib/currency';
import { cn } from '@/lib/utils';
import type { Deal, ProtectionPlan } from '@/models/types';
import { Shield } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ProtectionPlanEditorDialog } from './protection-plan-editor-dialog';

export const ProtectionPlanBadge = observer(function ProtectionPlanBadge({
  dealId,
  protectionPlan,
}: {
  dealId: Deal['id'];
  protectionPlan: ProtectionPlan | null;
}) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        className={cn('p-1 h-fit', {
          'text-gray-600': !protectionPlan,
        })}
        onClick={() => setDialogOpen(true)}
      >
        {!protectionPlan ? (
          <>
            <PDKEmptyValueIcon className="h-3.5 w-3.5" />
            <p className="rounded text-xs text-gray-600">None</p>
          </>
        ) : (
          <>
            <Shield className="h-3.5 w-3.5" />
            <div className="flex flex-col text-left items-start">
              <p className="text-xs text-gray-900 dark:text-white">
                {protectionPlan.name} ({protectionPlan.type})
              </p>
              <div className="text-xs text-gray-600 dark:text-gray-400">
                {protectionPlan.term_length} mo /{' '}
                {protectionPlan.term_miles.toLocaleString()} mi
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400">
                ${centsToInitialValue(protectionPlan.monthly_price)} / mo
              </div>
              <div className="text-xs text-gray-600 dark:text-gray-400">
                ${centsToInitialValue(protectionPlan.price)} total
              </div>
            </div>
          </>
        )}
      </Button>

      <ProtectionPlanEditorDialog
        dealId={dealId}
        protectionPlan={protectionPlan}
        open={dialogOpen}
        onOpenChange={setDialogOpen}
      />
    </>
  );
});
